import { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import CloudDownload from '@mui/icons-material/CloudDownload';
// import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import { reportFilterCountryCodeSelector } from '../../state';
import { useReportFilters } from './ReportFiltersProvider';

interface OnedriveButtonProps {
  disabled?: boolean;
  enableText?: boolean;
}

const TooltipWrapper = ({
  title,
  disabled,
  children,
}: {
  title: string;
  disabled: boolean;
  children: ReactElement;
}) => (!disabled ? <Tooltip title={title}>{children}</Tooltip> : children);

const OnedriveButton = ({ disabled, enableText }: OnedriveButtonProps) => {
  const dispatch = useDispatch();
  const { loadingSelector, onedriveAction } = useReportFilters();
  const handleClickOnedrive = useCallback(
    () => (onedriveAction ? dispatch(onedriveAction()) : null),
    [dispatch, onedriveAction]
  );
  const { t } = useTranslation();
  const loading = useSelector(loadingSelector);
  const hasCountry = Boolean(useSelector(reportFilterCountryCodeSelector));
  const applyDisabled = disabled || loading || !hasCountry;
  return onedriveAction ? (
    <TooltipWrapper title={t('toolbar.labels.sendToOnedrive') as string} disabled={applyDisabled}>
      <Button
        color="secondary"
        variant="contained"
        onClick={handleClickOnedrive}
        disabled={applyDisabled}
      >
        <CloudDownload />
        {enableText ? (
          <Box component="span" sx={{ ml: 0.5 }}>
            {t('navigation.buttons.saveInOneDrive')}
          </Box>
        ) : null}
      </Button>
    </TooltipWrapper>
  ) : null;
};

export default OnedriveButton;
